import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, colors, fontSizes, fontWeights } from '@/styles'
import ActiveLink from '@/components/active-link'

import { makeMainLayout } from './main'

const Container = styled.main`
  display: flex;
  justify-content: space-between;
  max-width: 940px;
  align-items: flex-start;
  margin: 0 auto;
  padding: 50px;
  margin-top: 60px;
  width: 100%;

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    flex-direction: column;
    margin-top: 0;
    padding: 50px 25px;
  }
`

const Menu = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    margin-bottom: 30px;
    display: flex;
    flex-wrap: wrap;
  }
`

const LinkWrapper = styled.li`
  display: inline;

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    margin-bottom: 10px;
  }

  :last-of-type {
    a {
      margin-right: 0;
    }
  }
`

const MenuLink = styled.a`
  font-size: 24px;
  font-weight: ${fontWeights.regular};
  margin-bottom: 50px;
  text-decoration: none;
  display: block;
  color: ${colors.regular};
  &.selected {
    color: ${colors.primary};
  }
  &:hover {
    opacity: 0.3;
  }

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    display: inline;
    font-size: ${fontSizes.regular};
    margin-right: 40px;
  }

  @media (max-width: 435px) {
    margin-right: 25px;
  }
`

const PageContainer = styled.section`
  width: 75%;

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    width: 100%;
  }
`

const MainLayout = makeMainLayout({ suppressRegisterModal: true })

interface Props {
  children?: React.ReactNode
}

const GeneralInformationLayout: React.FC<Props> = ({ children }) => {
  const { t } = useTranslation()
  return (
    <MainLayout>
      <Container>
        <Menu role="navigation">
          <LinkWrapper>
            <ActiveLink activeClassName="selected" href="/about" passHref>
              <MenuLink>{t('About Us')}</MenuLink>
            </ActiveLink>
          </LinkWrapper>
          <LinkWrapper>
            <ActiveLink activeClassName="selected" href="/terms" passHref>
              <MenuLink>{t('Terms')}</MenuLink>
            </ActiveLink>
          </LinkWrapper>
          <LinkWrapper>
            <ActiveLink activeClassName="selected" href="/privacy" passHref>
              <MenuLink>{t('Privacy')}</MenuLink>
            </ActiveLink>
          </LinkWrapper>
        </Menu>
        <PageContainer>{children}</PageContainer>
      </Container>
    </MainLayout>
  )
}

export default GeneralInformationLayout
